import styled from 'styled-components';
import colors from '../../includes/colors';

export const SmallTitle = styled.h3`
  color: ${colors.black};
  font-size: 1.0625rem;
  line-height: 1.25rem;
  font-weight: 300;
  @media (min-width: 768px) {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
  &.blue_variation {
    color: ${colors.darkBlue};
  }
  &.feature_size {
    font-size: 1.125rem;
    line-height: 1.375rem;
    @media (min-width: 768px) {
      font-size: 1.375rem;
      line-height: 1.625rem;
    }
    @media (min-width: 992px) {
      font-size: 1.5rem;
      line-height: 1.75rem;
    }
  }
`;